import React, { useState } from "react";
import { CssBaseline, Grid } from "@mui/material";
import SideNav from "components/sideNav/SideNav";
import Header from "components/header/Header";
import { drawerWidthEnum } from "utils/enumObj";
import { useStyles } from "./LayoutStyle";

const Layout = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(drawerWidthEnum.maxWidth);
  const [onlyMobile, setOnlyMobile] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
    if (open) {
      setDrawerWidth(drawerWidthEnum.maxWidth);
    } else {
      setDrawerWidth(drawerWidthEnum.minWidth);
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDrawerWidth(drawerWidthEnum.minWidth);
  };

  const handelOnMobile = () => {
    setOnlyMobile(!onlyMobile);
    setDrawerWidth(drawerWidthEnum.maxWidth);
  };

  return (
    <Grid className={classes.root}>
      <CssBaseline />
      <Grid container item className={classes.mainBody}>
        <SideNav
          open={open}
          onlyMobile={onlyMobile}
          onMobileOpen={handelOnMobile}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
        />
        <Grid
          item
          className={`${classes.content} formDiv`}
          sx={{
            flexGrow: 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Header handelOnlyOnMobile={handelOnMobile} />
          <div className="layoutChildren">{children}</div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Layout;
